module.exports = __webpack_public_path__ + "img/AssignActionGrey.009323a8.svg";